import { render, staticRenderFns } from "./queue.vue?vue&type=template&id=45b2cac2&scoped=true&"
import script from "./queue.vue?vue&type=script&lang=js&"
export * from "./queue.vue?vue&type=script&lang=js&"
import style0 from "./queue.vue?vue&type=style&index=0&id=45b2cac2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b2cac2",
  null
  
)

export default component.exports